import Component from "vue-class-component";

// Register the router hooks so they'll work in typescriptified class componentss...
//
// https://stackoverflow.com/questions/49235964/vue-js-router-not-calling-beforerouteupdate-typescript
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate"
]);